export default class BannerEnum {
	static VIDEO = '[data-banner-video]'
	static SLIDER = '[data-banner-slider]'
	static VOLUME_INDICATOR = '.js-volume-indicator'
}
